import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export interface PasswordInputsInterface {
  hasLetter: (value: string | undefined) => boolean;
  hasNumber: (value: string | undefined) => boolean;
}

export const schema = ({ hasLetter, hasNumber }: PasswordInputsInterface) => {
  const { t } = useTranslation(['create_new_password', 'common']);
  return yup.object().shape({
    password: yup
      .string()
      .required(t('common:password_required'))
      .min(8, t('min_length_password'))
      .test('number', t('password_has_number'), (value) => hasNumber(value))
      .test('letter', t('password_has_letter'), (value) => hasLetter(value)),
    confirmPassword: yup
      .string()
      .required(t('password_confirmation_required'))
      .oneOf([yup.ref('password')], t('password_not_match')),
  });
};
